module.exports = __webpack_public_path__ + "h5/img/huodong_3.7b9f2f54.jpg";